import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ClosedCaptions = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M2.844 7.166a2 2 0 0 1 2-2h14.5a2 2 0 0 1 2 2v10.5a2 2 0 0 1-2 2h-14.5a2 2 0 0 1-2-2z'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.395 11.015a1.75 1.75 0 1 0 0 2.802.75.75 0 0 1 .901 1.198 3.25 3.25 0 1 1 0-5.198.75.75 0 1 1-.901 1.198m4.213.163a1.75 1.75 0 0 1 2.287-.163.75.75 0 0 0 .901-1.198 3.25 3.25 0 1 0 0 5.198.75.75 0 1 0-.901-1.198 1.75 1.75 0 0 1-2.287-2.639'
          fill='currentColor'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.844 4.416a2.75 2.75 0 0 0-2.75 2.75v10.5a2.75 2.75 0 0 0 2.75 2.75h14.5a2.75 2.75 0 0 0 2.75-2.75v-10.5a2.75 2.75 0 0 0-2.75-2.75zm5.55 6.6a1.75 1.75 0 1 0 0 2.8.75.75 0 1 1 .901 1.2 3.25 3.25 0 1 1 0-5.2.75.75 0 0 1-.902 1.2m4.212.163a1.75 1.75 0 0 1 2.287-.164.75.75 0 1 0 .902-1.198 3.25 3.25 0 1 0 0 5.198.75.75 0 0 0-.902-1.198 1.75 1.75 0 0 1-2.287-2.638'
        fill='currentColor'
      />
    )}
  </IconBase>
);
